import ZendeskAPIProvider from './ZendeskAPIProvider'

export default ZendeskAPIProvider

export { useZendeskAPI } from './ZendeskAdaptor'
